import axios from 'axios'

class AuthService {
    login(user) {
        var API_URL = process.env.VUE_APP_URL + '/api/auth/'
        return axios.post(API_URL + 'signin', {
            username: user.username,
            password: user.password
        })
        .then(response => {
            if (response.data.accessToken) {
                localStorage.setItem('user', JSON.stringify(response.data))
            }
            return response.data
        })
      .catch((err) => {
          console.log(err)
          return Promise.reject()
        })  
    }

    signup(usuario) {
        var API_URL = process.env.VUE_APP_URL + '/api/auth/'
        return axios.post(API_URL, usuario)
    }

    logout() {
        localStorage.removeItem('user')
    }

    expresos() {
        var API_URL = process.env.VUE_APP_URL + '/api/auth/expresos'
        return axios.get(API_URL)
    }
    zonas() {
        var API_URL = process.env.VUE_APP_URL + '/api/auth/zonas'
        return axios.get(API_URL)
    }

    tipoCliente() {
        var API_URL = process.env.VUE_APP_URL + '/api/auth/tipoCliente'
        return axios.get(API_URL)
    }

    requestToken(mail) {
        var API_URL = process.env.VUE_APP_URL + '/api/auth/'
        return axios.get(API_URL + 'cambiarContra?mail=' + mail)
    }

    changePassword(mail, token, password) {
        var API_URL = process.env.VUE_APP_URL + '/api/auth/'
        return axios.put(API_URL + 'cambiarContra?email=' + mail + '&token=' + token + '&contra=' + password)
    }

    getPadron(cuit) {
        var API_URL = process.env.VUE_APP_URL + '/api/auth/'
        return axios.get(API_URL + 'padron?cuit=' + cuit)
    }
}

export default new AuthService()